export const CLOSE_BEACON_PATH = '/api/sync/v1/close';
